import { Container, Toolbar } from '@mui/material';
import PropTypes from 'prop-types';

export const v2ContentContainerSx = {
  // 1280px content area plus MUI Container's two 24px desktop gutters.
  maxWidth: 1328,
};

const V2ContentContainer = ({ children, sx = [], ...props }) => {
  const additionalSx = Array.isArray(sx) ? sx : [sx];

  return (
    <Container
      {...props}
      maxWidth={false}
      sx={[v2ContentContainerSx, ...additionalSx]}
    >
      {children}
    </Container>
  );
};

export const V2ContentToolbar = ({ children, ...props }) => (
  <V2ContentContainer>
    <Toolbar {...props} disableGutters>
      {children}
    </Toolbar>
  </V2ContentContainer>
);

V2ContentContainer.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.bool, PropTypes.func, PropTypes.object])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

V2ContentToolbar.propTypes = {
  children: PropTypes.node,
};

export default V2ContentContainer;
